require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

import {ComponentService} from "./service/component";
import container from "./container/config";
import SERVICE_IDENTIFIER from "./container/identifiers";
import {Application} from "./application/application";
import {NavigationComponent} from "./components/navigation";
import {CarouselBanner} from "./components/carousel-banner";
import {ProductsCarousel} from "./components/products-carousel";
import {Product} from "./components/product";
import {ProductAdviceAccordion} from "./components/product-advice-accordion";
import {ProductVariants} from "./components/product-variations";
import {RecipeCard} from "./components/recipe-card";
import {RecipeList} from "./components/recipe-list";
import {DisplayOnScroll} from "./components/page-scroll-events";
import {ScrollToAnchor} from "./components/scroll-to-anchor";
import {RecyclingLoopAnimation} from "./components/recycling-loop";
import {OverlappingPhotoTiles} from "./components/overlapping-photo-tiles";
import {HistoryFeature} from "./components/history-feature";
import {ProductGrid} from "./components/product-grid";
import {RecipeBanner} from "./components/recipe-banner";
import {PinboardTiles} from "./components/pinboard-tiles";
import {SocialComponent} from "./components/social";
import {NewsletterSignupComponent} from "./components/newsletter-signup";
import {EnquiryFormComponent} from "./components/enquiry-form";

(($) => $(() => {

    (<any>window).recaptchaInit = () => {
        return new Promise(resolve => {
            let promises:Promise<void>[] = [];
            $('.js-newsletter-form,.js-enquiry-form').each((key: number, element: HTMLElement) => {
                promises.push(new Promise(resolve => {
                    let interval = setInterval(() => {
                        if ($(element).data('initialised')) {
                            clearInterval(interval);
                            $(element).trigger('recaptcha-ready');
                            resolve();
                        }
                    }, 1000);
                }));
            });
            Promise.all(promises).then(() => resolve());
        });
    };

    let components = container.get<ComponentService>(SERVICE_IDENTIFIER.COMPONENTS);
    components.addComponent('.js-primary-nav', NavigationComponent);
    components.addComponent('.js-carousel-banner', CarouselBanner);
    components.addComponent('.js-products-carousel', ProductsCarousel);
    components.addComponent('.js-product', Product);
    components.addComponent('.js-product-advice', ProductAdviceAccordion);
    components.addComponent('.js-product-variations', ProductVariants);
    components.addComponent('.js-recipe-card', RecipeCard);
    components.addComponent('.js-recipe-list', RecipeList);
    components.addComponent('.js-dsp-on-scroll', DisplayOnScroll);
    components.addComponent('.js-scroll-to-anchor', ScrollToAnchor);
    components.addComponent('.js-recycling-loop', RecyclingLoopAnimation);
    components.addComponent('.js-overlapping-photo-tiles', OverlappingPhotoTiles);
    components.addComponent('.js-history-feature', HistoryFeature);
    components.addComponent('.js-product-grid', ProductGrid);
    components.addComponent('.js-recipe-banner', RecipeBanner);
    components.addComponent('.js-pinboard', PinboardTiles);
    components.addComponent('.js-share', SocialComponent);
    components.addComponent('.js-newsletter-form', NewsletterSignupComponent);
    components.addComponent('.js-enquiry-form', EnquiryFormComponent);
    // components.addComponent('#mailinglist-signup', MailingListSignup);

    container.get<Application>(SERVICE_IDENTIFIER.APPLICATION).init();

}))(jQuery);